import { useEffect, useState } from 'react';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
} from '../../../common/components';
import {
  useCreateMovementConcept,
  useUpdateMovementConcept,
} from '../../../hooks/useMovementConcepts';
import {
  INITIAL_MOVEMENT_CONCEPT_STATE,
} from '../constants/movementConceptsConstants';
import {
  validateMovementConcept,
  prepareMovementConceptData,
} from '../utils/movementConceptValidation';
import GeneralDataSection from './GeneralDataSection';

const MovementConceptDialog = ({ open, onClose, editMode, selectedMovementConcept }) => {
  const [formData, setFormData] = useState(INITIAL_MOVEMENT_CONCEPT_STATE);
  const [errors, setErrors] = useState({});

  const createMovementConceptMutation = useCreateMovementConcept();
  const updateMovementConceptMutation = useUpdateMovementConcept();

  useEffect(() => {
    if (editMode && selectedMovementConcept) {
      setFormData({
        name: selectedMovementConcept.name || '',
        code: selectedMovementConcept.code || '',
        description: selectedMovementConcept.description || '',
        is_active:
          selectedMovementConcept.is_active === undefined
            ? true
            : Boolean(selectedMovementConcept.is_active),
      });
    } else {
      setFormData(INITIAL_MOVEMENT_CONCEPT_STATE);
    }
    setErrors({});
  }, [selectedMovementConcept, editMode, open]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleSave = async () => {
    const validationErrors = validateMovementConcept(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = prepareMovementConceptData(formData);

    try {
      if (editMode && selectedMovementConcept) {
        await updateMovementConceptMutation.mutateAsync({
          id: selectedMovementConcept.uuid,
          data: payload,
        });
      } else {
        await createMovementConceptMutation.mutateAsync(payload);
      }
      onClose();
    } catch (error) {
      console.error('Error al guardar concepto de movimiento:', error);
    }
  };

  const isLoading =
    createMovementConceptMutation.isPending || updateMovementConceptMutation.isPending;

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode ? 'Editar Concepto de Movimiento' : 'Nuevo Concepto de Movimiento'}
      </DialogTitle>

      <DialogBody>
        <GeneralDataSection formData={formData} errors={errors} onChange={handleInputChange} />
      </DialogBody>

      <DialogActions
        handleClose={onClose}
        handleSave={handleSave}
        saveText={editMode ? 'Actualizar' : 'Crear'}
        isSaving={isLoading}
      />
    </DialogContainer>
  );
};

export default MovementConceptDialog;
